import React from 'react';
import {observer} from 'mobx-react';
import OffboardingContainerWithState from './OffboardingContainerWithState';
import EmployeeProfileContainer from '../../EmployeeProfileContainer';

const OffboardingContainer = observer(({uiState}) => {
  return (
    <EmployeeProfileContainer uiState={uiState}>
      <OffboardingContainerWithState parentState={uiState}/>
    </EmployeeProfileContainer>
  );
});

export default OffboardingContainer;
